// Name: AccessRestricted.tsx

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { AccordionBody } from 'react-bootstrap';
import { FadeAccordion, FadeAccordionItem } from './Transitions';
import { DenyIcon } from './Icons';

type Props = {
  title: string;
  subTitle?: string;
  message?: string;
  subMessage?: string;
};

const AccessRestricted: React.FC<Props> = ({
  title, 
  subTitle = 'Access Restricted',
  message = 'You do not have access to view this section.',
  subMessage = 'If you believe this is a mistake, please contact your administrator.',
}) => {
  return (
    <Row>
      <Col sm={12} as="h1" className="mb-3 text-muted">
        {title}
      </Col>

      <Col xl={9}>
        <FadeAccordion defaultActiveKey="1">
          <FadeAccordionItem eventKey="1">
            <AccordionBody className="text-center">
              <Row className="justify-content-center py-5">
                <Col lg={10} xl={8}>
                  <DenyIcon className="mb-2 text-danger" />
                  <h1 className="mb-2 text-danger">{subTitle}</h1>
                  <p className="mb-1">{message}</p>
                  <p className="mb-0">{subMessage}</p>
                </Col>
              </Row>
            </AccordionBody>
          </FadeAccordionItem>
        </FadeAccordion>
      </Col>
    </Row>
  );
};

export default AccessRestricted;
